'use client';

import React from 'react';
import AppLayout from '@/components/AppLayout';
import GRNHeader from './components/GRNHeader';
import GRNRegistrationForm from './components/GRNRegistrationForm';

export default function InboundGRNPage() {
  return (
    <AppLayout>
      <div className="flex flex-col h-full min-h-screen">
        <GRNHeader />
        <GRNRegistrationForm />
      </div>
    </AppLayout>
  );
}
